import React from 'react';
import {PostDemandContent} from './sub-view/post-demand-content';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessPostDemandContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <BusinessLayout active="post-demand">
        <h1 className="user-header">Chào hàng/Yc báo giá</h1>
        <PostDemandContent/>
      </BusinessLayout>
    );
  }
}

export default MyBusinessPostDemandContainer;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessPostDemandContainer.jsx